export default "__VITE_ASSET__1d9a8ed1__"